import axios from "axios";
import store from "/store/index"
import { CLEAR_USER } from "/store/mutation-types";
import router from "../router";

 //axios.defaults.baseURL = "/devapi/";//"https://stock-api.deyiiot.com/";//"http://192.168.1.108:11015/"; //本地测试 //api变更时需要修改
 axios.defaults.baseURL = "https://stock-api.deyiiot.com/";//"/devapi/";//"http://192.168.1.108:11015/"; //生产环境

const $axios = axios.create({
  timeout: 20000,
  responseType: "json",
  withCredentials: true
});

/**
 * 移除value=undefined的key
 *
 * @param {*} config
 */
function removeUndefined(config) {
  console.log('before config', config);
  // get方式提交, 数据存储在config.params
  if (config.params) {
    let params = config.params;
    for (let p in params) {
      if (params[p] === undefined) {
        delete params[p];
      }
    }
  }

  // post表单方式提交,数据存储在config.data,对象类型URLSearchParams
  if (config.data) {
    let data = config.data;
    if (data.constructor.name === "URLSearchParams") {
      console.log("config.data", config.data);
      const deletedParams = [];
      for (let p of data) {
        if (p[1] === "undefined" || p[1] === "null") {
          deletedParams.push(p[0]);
        }
      }
      deletedParams.map(param => {
        data.delete(param);
      });
    }

    // post json方式提交,数据存储在config.data
    if (data.constructor.name === "Object") {
      for (let p in data) {
        if (data[p] === undefined) {
          delete data[p];
        }
      }
    }
  }
}

/**
 * 请求拦截器
 */
$axios.interceptors.request.use(
  config => {
    removeUndefined(config);
    if (!window.navigator.onLine) {
      return {
        title: "网络错误",
        content: "检测到您的网络已断开，请稍后再试！"
      };
    }

    let loginInfo = store.getters.getLoginInfo || {};
    if (loginInfo.token) {
      config.headers["X-AuthToken"] = loginInfo.token;
    }
    // if (loginInfo.operatorId) {
    //   config.headers["X-OperatorId"] = loginInfo.operatorId;
    // }
    config.headers["X-AppName"] = "dysys";
    config.headers["X-ClientType"] = "web";
    config.headers["X-ClientOS"] = "pc";
    config.headers["X-AppVersion"] = 1.0;
    return config;
  },
  error => {
    console.log("error", error);
    return {
      title: "请求错误",
      content: "请稍后再试"
    };
  }
);

/**
 * 响应拦截器
 */
$axios.interceptors.response.use(
  res => {
    if (res.status != 200) {
      return Promise.reject("响应错误");
    }

    // 接口错误码处理
    let code = res.data.code;

    if (code != 200) {
      if (code == "401") {
        // 未登录，自动跳转到登录页面
        // 清空本地缓存
        store.commit(CLEAR_USER);
        router.push("/dengLu");
        return Promise.reject(res.data.msg);
      } else {
        console.log(res.data.msg);
        return Promise.reject(res.data.msg);
      }
    }

    // 接口请求成功
    if (code == 200) {
      logRequest(res);
      return Promise.resolve(res.data.data);
    }

    return res;
  },
  error => {
    console.log("response error", error);
    let msg = "";
    if (error && error.response) {
      msg = "请求错误";
    } else {
      msg = "连接失败";
    }
    console.log(msg);
    return Promise.reject(msg);
  }
);

function logRequest(res) {
  let param = undefined;
  if (res.config.data) {
    param = res.config.data;
  } else if (res.config.params) {
    param = res.config.params;
  }
  console.log("url", res.config.url, "param", param, "data", res.data.data);
}

/**
 * 在普通js中，直接导入
 */
export { $axios };

/**
 * 在vue组件中，直接通过上下文this使用$axios
 * 需要在main.js调用Vue.use();
 */
export default {
  install(Vue) {
    Vue.prototype.$axios = $axios;
  }
};

/**
 * 判断是否通过CancelToken取消的请求
 */
export const isAxiosCancel = axios.isCancel;

export const serverUrl = axios.defaults.baseURL;



// WEBPACK FOOTER //
// ./src/util/axios.js